import { useEffect, useState } from 'react';
import { Modal } from '../../design';
import { useClient } from '../../lib/hooks';
import { errorText } from '../format';

type Row = Awaited<ReturnType<ReturnType<typeof useClient>['listAllGroups']>>[number];

/**
 * Mọi nhóm mình còn là thành viên theo server. Nhóm đã có trên thiết bị này mở được ngay; nhóm chưa đồng bộ (đăng nhập
 * lại = thiết bị mới, chờ một thiết bị khác của nhóm thêm vào) hiện kèm trạng thái và tự có trong danh sách khi xong.
 */
export function AllGroupsDialog({ onClose, onOpen }: { onClose: () => void; onOpen: (id: string) => void }) {
  const client = useClient();
  const [rows, setRows] = useState<Row[]>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    let alive = true;
    void client
      .loadUsers()
      .catch(() => undefined)
      .then(() => client.listAllGroups())
      .then((r) => alive && setRows(r))
      .catch((e) => alive && setError(errorText(e)));
    return () => {
      alive = false;
    };
  }, [client]);

  return (
    <Modal title="Tất cả nhóm" onClose={onClose} testId="all-groups-dialog">
      {error && (
        <div className="ws-error" role="alert">
          {error}
        </div>
      )}
      {!rows && !error && <p className="ws-small">Đang tải…</p>}
      {rows && !rows.length && <p className="ws-small">Bạn chưa tham gia nhóm nào.</p>}
      <ul className="ws-list" data-testid="all-groups-list">
        {rows?.map((g) => (
          <li key={g.id}>
            <button type="button" className="ws-conv" data-testid="all-groups-item" data-synced={g.synced} disabled={!g.synced} onClick={() => onOpen(g.id)}>
              <span>{g.title}</span>
              <span className="ws-small">
                {' '}
                · {g.member_count} thành viên{g.synced ? '' : ' · đang chờ đồng bộ trên thiết bị này'}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
